export default {
  name: 'Header',
  displayName: {
    en: 'Header',
    ja: 'ヘッダー',
  },
  defaultWidth: 375,
  defaultHeight: 64,
  resizeX: true,
  screens: {
    desktop: {
      width: 1200,
      height: 64,
    },
    tablet: {
      width: 768,
      height: 64,
    },
    mobile: {
      width: 375,
      height: 64,
    },
  },
  props: [
    {
      name: 'menuListActions',
      type: 'action',
      displayName: {
        en: 'Menu List Actions',
        ja: 'メニューリストアクション',
      },
      reference: 'items',
    },
  ],
  childComponents: [
    {
      name: 'logo',
      displayName: {
        en: 'Logo',
        ja: 'Logo',
      },
      props: [
        {
          name: 'imageLogo',
          displayName: {
            en: 'Image Source',
            ja: '画像ソース',
          },
          type: 'image',
          default: [],
        },
      ],
    },
    {
      name: 'menuList',
      displayName: {
        en: 'Menu Lists',
        ja: 'Menu Lists',
      },
      props: [
        {
          name: 'items',
          displayName: {
            en: 'Menu Items',
            ja: 'メニュー項目',
          },
          type: 'dynamicListIcon',
          default: [
            {
              id: 'menu-group',
              text: 'メニー',
              type: 'group',
              children: [
                { id: 'home', text: 'ホーム', icon: 'home', type: 'item' },
                { id: 'list', text: '一覧', icon: 'list', type: 'item' },
                {
                  id: 'favorites',
                  text: 'お気に入り',
                  icon: 'star',
                  type: 'item',
                },
              ],
            },
            {
              id: 'mypage-group',
              text: 'マイページ',
              type: 'group',
              children: [
                {
                  id: 'profile',
                  text: 'プロフィール',
                  icon: 'person',
                  type: 'item',
                },
                {
                  id: 'notifications',
                  text: '通知',
                  icon: 'notifications',
                  type: 'item',
                },
                {
                  id: 'settings',
                  text: '設定',
                  icon: 'settings',
                  type: 'item',
                },
              ],
            },
            {
              id: 'other-group',
              text: 'その他',
              type: 'group',
              children: [
                {
                  id: 'logout',
                  text: 'ログアウト',
                  icon: 'exit-to-app',
                  type: 'item',
                },
                {
                  id: 'help',
                  text: 'ヘルプページ',
                  icon: 'help',
                  type: 'item',
                },
              ],
            },
          ],
        },
      ],
    },
    {
      name: 'leftMenuPosition',
      type: 'boolean',
      displayName: {
        en: 'Left Menu Position',
        ja: 'Left Menu Position',
      },
      props: [
        {
          name: 'enabled',
          type: 'boolean',
          default: true,
        },
      ],
    },
    {
      name: 'actionIcon1',
      displayName: {
        en: 'Action Icon 1',
        ja: 'アクションアイコン 1',
      },
      actions: true,
      props: [
        {
          name: 'icon',
          displayName: {
            en: 'Icon',
            ja: 'アイコン',
          },
          type: 'icon',
          default: 'email',
        },
        {
          name: 'enabled',
          type: 'boolean',
          default: true,
        },
        {
          name: 'action',
          type: 'action',
          displayName: {
            en: 'Actions',
            ja: 'アクション',
          },
        },
      ],
    },
    {
      name: 'actionIcon2',
      displayName: {
        en: 'Action Icon 2',
        ja: 'アクションアイコン 2',
      },
      actions: true,
      props: [
        {
          name: 'icon',
          displayName: {
            en: 'Icon',
            ja: 'アイコン',
          },
          type: 'icon',
          default: 'notifications',
        },
        {
          name: 'enabled',
          type: 'boolean',
          default: true,
        },
        {
          name: 'action',
          type: 'action',
          displayName: {
            en: 'Actions',
            ja: 'アクション',
          },
        },
      ],
    },
    {
      name: 'actionIcon3',
      displayName: {
        en: 'Action Icon 3',
        ja: 'アクションアイコン 3',
      },
      actions: true,
      props: [
        {
          name: 'icon',
          displayName: {
            en: 'Icon',
            ja: 'アイコン',
          },
          type: 'icon',
          default: 'help',
        },
        {
          name: 'enabled',
          type: 'boolean',
          default: true,
        },
        {
          name: 'action',
          type: 'action',
          displayName: {
            en: 'Actions',
            ja: 'アクション',
          },
        },
      ],
    },
  ],
  resizeY: false,
  style: {
    backgroundColor: true,
    text: true,
    color: true,
    zIndex: true,
  },
};
